import React from "react";
import { Membership } from "types";
import { MembershipPurchaseItem } from "types/src/types/MembershipPurchaseItem";
import { PurchaseRuleTile } from "@/components/PurchaseCreate/CreatePurchaseProductRestrictions";
import { useMembershipRedemptionRule } from "@/components/PurchaseCreate/hooks/useMembershipRedemptionRule";
import {
    getTerms,
    MembershipBenefitsTiles,
    MembershipRestrictionsTiles,
} from "@/components/PurchaseCreate/Membership/CreatePurchaseMembershipTerms";

interface MembershipPurchaseTermsProps {
    membership: Membership;
    item?: MembershipPurchaseItem;
}

export const MembershipPurchaseTerms = ({ membership, item }: MembershipPurchaseTermsProps) => {
    const { data: redemptionPurchaseRule } = useMembershipRedemptionRule(membership);
    if (!redemptionPurchaseRule) return null;

    const terms = getTerms(membership, redemptionPurchaseRule, item?.createdAt);

    return (
        <div className="space-y-4">
            <h3 className="text-xl font-bold">Terms</h3>
            <div className="space-y-1">
                <MembershipBenefitsTiles terms={terms} />
                <MembershipRestrictionsTiles isWide terms={terms} redemptionPurchaseRule={redemptionPurchaseRule} />
                {terms.organizerRequired && (
                    <PurchaseRuleTile title="Card Holder Restriction">
                        Members must carry a valid ID at the time of check-in to experiences booked with this membership
                    </PurchaseRuleTile>
                )}
            </div>
        </div>
    );
};
